import { StatsApi } from 'clientSDK';
import dotenv from 'dotenv';
dotenv.config();

const statsApi = new StatsApi();

export default {
  getCollections: async () => {
    try {
      const responseData = await statsApi.getCollectionPriceStats();
      return responseData;
    } catch (err) {
      console.error(err);
    }
  },

  getCollectionStats: async (address) => {
    try {
      const responseData = await statsApi.getCollectionStats(address);
      return responseData;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  getActivities: async ({
    collection,
    listing = true,
    mint = true,
    sale = true,
    transfer = true,
    burn = true,
    offer = true,
    bid = true,
    skip = 0,
    limit = 50,
    date,
  }) => {
    try {
      const responseData = await statsApi.getActivityStats({
        collection,
        listing,
        mint,
        sale,
        offer,
        bid,
        transfer,
        burn,
        skip,
        limit,
        date,
      });
      return responseData;
    } catch (err) {
      console.error(err);
    }
  },

  getTopCollections: async ({
    market = 'all',
    period = 0,
    direction = 'desc',
    skip = 0,
    limit = 100,
  }) => {
    try {
      const responseData = await statsApi.getTopCollectionsStats({
        market,
        period,
        direction,
        skip,
        limit,
      });
      return responseData;
    } catch (err) {
      console.error(err);
    }
  },

  getUserActivities: async ({
    address,
    collection,
    listing = true,
    sale = true,
    offer = true,
    bid = true,
    transfer = true,
    mint = true,
    burn = true,
    skip = 0,
    limit = 50,
    date,
  }) => {
    try {
      const responseData = await statsApi.getUserActivityStats({
        address,
        collection,
        listing,
        mint,
        sale,
        offer,
        bid,
        transfer,
        burn,
        skip,
        limit,
        date,
      });
      return responseData;
    } catch (err) {
      console.error(err);
    }
  },
};
